<template>
  <section
    class="hero section illustration-section-01"
    :class="[
      topOuterDivider && 'has-top-divider',
      bottomOuterDivider && 'has-bottom-divider',
      hasBgColor && 'has-bg-color',
      invertColor && 'invert-color',
    ]"
  >
    <div class="container">
      <div
        class="hero-inner section-inner"
        :class="[
          topDivider && 'has-top-divider',
          bottomDivider && 'has-bottom-divider',
        ]"
      >
        <div
          class="split-wrap"
          :class="[
            invertMobile && 'invert-mobile',
            invertDesktop && 'invert-desktop',
            alignTop && 'align-top',
          ]"
        >
          <div class="split-item">
            <div
              class="hero-content split-item-content center-content-mobile reveal-from-top"
            >
              <h1 class="mt-0 mb-16">{{ $t("student.title") }}</h1>
              <p class="mt-0 mb-32">{{ $t("student.subtitle") }}</p>
              <c-button-group>
                <c-button
                  tag="a"
                  color="primary"
                  wide-mobile
                  @click="submitApplication"
                  >{{ $t("student.primaryAction") }}</c-button
                >
              </c-button-group>
            </div>
            <div
              class="hero-figure split-item-image split-item-image-fill illustration-element-01 reveal-from-bottom"
            >
              <c-image
                :src="require('@/assets/images/student.jpg')"
                alt="Remote working student"
                :width="528"
                :height="396"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { SectionSplitProps } from "@/utils/SectionProps.js";
import CButtonGroup from "@/components/elements/ButtonGroup.vue";
import CButton from "@/components/elements/Button.vue";
import CImage from "@/components/elements/Image.vue";

export default {
  name: "CHeroSplit",
  components: {
    CButtonGroup,
    CButton,
    CImage,
  },
  mixins: [SectionSplitProps],
  methods: {
    submitApplication() {
      window.analytics.track("Student registration");
      window.scrollTo(0, document.body.scrollHeight);
    },
  },
  computed: {
    yourName() {
      return this.$i18n.t("about.contact.name");
    },
    yourEmail() {
      return this.$i18n.t("about.contact.email");
    },
    yourPhone() {
      return this.$i18n.t("about.contact.phone");
    },
  },
};
</script>

<style lang="scss" scoped>
a {
  text-decoration: none !important;
}
.split-item-image img {
  border-radius: 4px;
}
</style>
